<template>


	<div class="mt-4 mb-4 ss-payment">
		<p>Selected Plan: {{selectedPlan.title}}</p>
		<p>Payment: {{selectedPlan.newPrice}} </p>Plan Type: {{selectedPlan.planType}}<h4>Enter your payment information below to complete your purchase</h4>
		<transition name="list">
			<div class="row" v-show="intro === false && paymentReady === false">

				<div class="col-md-4 offset-md-4 mb-2 mt-4">
					<div style="max-width: 400px; margin: auto">

						<div class="text-right" style="color: #cc6600">
							<i class="fa fa-lock"></i> Secure Server
						</div>

						<div class="payment-selector" @click="formData.method = 'ach'; paymentReady = true">
							<div class="text">ACH checking or savings</div> <div class="icons"><icon-check /></div>
						</div>
						<div class="payment-selector" @click="formData.method = 'card'; paymentReady = true;">
							<div class="text">Credit or debit card</div> <div class="icons"><icon-visa /><icon-mastercard /><icon-amex /><icon-discover /><icon-diners /></div>
						</div>

					</div>

					<div class="text-center">
						<el-button :disabled="thinking.save" class="mb-2" type="primary" @click.stop="$emit('back')">Cancel</el-button>
					</div>

				</div>



			</div>
		</transition>
		<transition name="list">
			<div class="row" v-show="paymentReady">

				<div class="col-md-12 mb-2 mt-4" v-loading="thinking.save" v-if="formData.method === 'card'">

					<div class="text-center d-block">
						<a class="text-primary" style="cursor: pointer" @click="formData.method = 'ach'">Use Bank Account</a>
					</div>

					<div class="cwrapper">


						<CardForm :form-data="formData"
											ref="cardForm"
											v-loading="thinking.save"
											@valid="emitForm"
											@invalid="serverError = $event" />


					</div>


					<div class="text-center">
						<a class="text-primary" style="cursor: pointer" @click="paymentReady = false">Go back</a>
					</div>



				</div>

				<div v-else class="col-md-12 mb-2 mt-4" v-loading="thinking.save">

					<div class="text-center d-block">
						<a class="text-primary" style="cursor: pointer" @click="formData.method = 'card'">Use credit card instead</a>
					</div>

					<div class="cwrapper">
						<ACHForm :form-data="formData"
										 ref="bankForm"
										 v-loading="thinking.save"
										 :selected-plan="selectedPlan"
										 @valid="emitForm"
										 @invalid="serverError = $event" />

					</div>


					<div class="text-center">
						<a class="text-primary" style="cursor: pointer" @click="paymentReady = false">Go back</a>
					</div>
				</div>



			</div>
		</transition>



	</div>

	




</template>

<script>
	
	
	import CardForm from "@/components/payment/components/CardForm.vue";
	import ACHForm from "@/components/payment-ach/components/CardForm.vue";
	import amex from "@/components/icons/amex.vue";
	import diners from "@/components/icons/diners.vue";
	import mastercard from "@/components/icons/mastercard.vue";
	import visa from "@/components/icons/visa.vue";
	import discover from "@/components/icons/discover.vue";
	import check from "@/components/icons/check.vue";

	export default {
		name: "payment",
		components: {
			[amex.name]: amex,
			[diners.name]: diners,
			[mastercard.name]: mastercard,
			[visa.name]: visa,
			[discover.name]: discover,
			[check.name]: check,
			CardForm,
			ACHForm
		},
		props: {
			selectedPlan: Object
    },
		data() {
			return {
				intro: false,
				thinking: {
					save: false
				},

				
				serverError: null,

				paymentReady: false,
								
				formData: {
					method: 'card',

					firstname: '',
					lastname: '',
					cardName: '',
					cardNumber: '',
					cardMonth: '',
					cardYear: '',
					cardCvv: '',
					cardZip: '',

					bankName: '',
					accountType: '',
					routingNumber: '',
					accountNumber: ''
				}

												
			}
		},

		
		
		methods: {
						
			
			submit() {
				
				if (!this.paymentReady) {
					return false;
				}

				this.submitForm();
      },

			submitForm() {

        if (this.formData.method === 'card') {
          this.$refs.cardForm.handleSubmit();
        } else {
          this.$refs.bankForm.handleSubmit();
        }				
			},

			emitForm() {
				this.$emit("payment", this.formData);
      }

			
			
		},

		watch: {
			
		}
	}
</script>

<style scoped>

	.payment-selector {
		border: 1px solid #ccc;
    border-radius: 2px;
    cursor: pointer;
		position: relative;
		height: 50px;
		transition: all 0.3s;
		margin-bottom: 5px;
	}
	.payment-selector:hover {
		background: rgba(0, 0, 0, .05);
	}
	.payment-selector .text {
		font-size: 14px;
		position: absolute;
		left: 8px;
		top: 12px;
	}
	.payment-selector .icons {
		position: absolute;
    right: 8px;
    top: 12px;
	}
	.intro-wrapper {
		max-width: 400px;
		margin: auto;
	}
	.checks {
		
		max-width: 400px;
		margin: auto;		
		
	}

	svg {
		width: 25px;
		position: relative;
		top: -12px
	}

	.check {
		position: relative;
		font-size: 18px;
	}
	.check p {
		font-size: 16px;
		margin-bottom: 15px;
		color: #333;
	}

		.check i {
			position: relative;
			right: -5px;
			top: 5px;			
		}

		.list-enter,
	.list-leave-to {
		visibility: hidden;
		height: 0;
		margin: 0;
		padding: 0;
		opacity: 0;
	}

	.list-enter-active,
	.list-leave-active {
		transition: all 0.3s;
	}
</style>

